import { render, staticRenderFns } from "./FirstWdr.vue?vue&type=template&id=406ac218&"
import script from "./FirstWdr.vue?vue&type=script&setup=true&lang=js&"
export * from "./FirstWdr.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports